import { SpinnerProps } from '@procore/core-react/dist/_typedoc/Spinner/Spinner.types.json';
import * as React from 'react';
export default {
  SpinnerProps,
  React
};